import accountCircleOutline from '@iconify-icons/mdi/account-circle-outline'
import accountGroup from '@iconify-icons/mdi/account-group'
import arrowUpDown from '@iconify-icons/mdi/arrow-up-down'
import bookMultiple from '@iconify-icons/mdi/book-multiple'
import cart from '@iconify-icons/mdi/cart'
import check from '@iconify-icons/mdi/check'
import chevronDoubleLeft from '@iconify-icons/mdi/chevron-double-left'
import chevronDoubleRight from '@iconify-icons/mdi/chevron-double-right'
import close from '@iconify-icons/mdi/close'
import cogOutline from '@iconify-icons/mdi/cog-outline'
import commentQuestionOutline from '@iconify-icons/mdi/comment-question-outline'
import currencyCny from '@iconify-icons/mdi/currency-cny'
import dotsHorizontal from '@iconify-icons/mdi/dots-horizontal'
import fileDocumentMultipleOutline from '@iconify-icons/mdi/file-document-multiple-outline'
import fileDocumentOutline from '@iconify-icons/mdi/file-document-outline'
import fileTree from '@iconify-icons/mdi/file-tree'
import lightbulbOnOutline from '@iconify-icons/mdi/lightbulb-on-outline'
import folderOpenOutline from '@iconify-icons/mdi/folder-open-outline'
import folderOutline from '@iconify-icons/mdi/folder-outline'
import helpCircle from '@iconify-icons/mdi/help-circle'
import keyVariant from '@iconify-icons/mdi/key-variant'
import lockOutline from '@iconify-icons/mdi/lock-outline'
import menu from '@iconify-icons/mdi/menu'
import menuOpen from '@iconify-icons/mdi/menu-open'
import messageText from '@iconify-icons/mdi/message-text'
import messageTextOutline from '@iconify-icons/mdi/message-text-outline'
import minus from '@iconify-icons/mdi/minus'
import pageFirst from '@iconify-icons/mdi/page-first'
import pageLast from '@iconify-icons/mdi/page-last'
import pauseCircleOutline from '@iconify-icons/mdi/pause-circle-outline'
import pencil from '@iconify-icons/mdi/pencil'
import plus from '@iconify-icons/mdi/plus'
import plusCircleOutline from '@iconify-icons/mdi/plus-circle-outline'
import reload from '@iconify-icons/mdi/reload'
import schoolOutline from '@iconify-icons/mdi/school-outline'
import shieldAccount from '@iconify-icons/mdi/shield-account'
import sync from '@iconify-icons/mdi/sync'
import tagOutline from '@iconify-icons/mdi/tag-outline'
import trashCanOutline from '@iconify-icons/mdi/trash-can-outline'
import translate from '@iconify-icons/mdi/translate'
import viewDashboard from '@iconify-icons/mdi/view-dashboard'
import viewQuiltOutline from '@iconify-icons/mdi/view-quilt-outline'
import type { IconRegistry } from '@vea/components'

export const icons = {
  'mdi:account-circle-outline': accountCircleOutline,
  'mdi:account-group': accountGroup,
  'mdi:arrow-up-down': arrowUpDown,
  'mdi:book-multiple': bookMultiple,
  'mdi:cart': cart,
  'mdi:check': check,
  'mdi:chevron-double-left': chevronDoubleLeft,
  'mdi:chevron-double-right': chevronDoubleRight,
  'mdi:close': close,
  'mdi:cog-outline': cogOutline,
  'mdi:comment-question-outline': commentQuestionOutline,
  'mdi:currency-cny': currencyCny,
  'mdi:dots-horizontal': dotsHorizontal,
  'mdi:file-document-multiple-outline': fileDocumentMultipleOutline,
  'mdi:file-document-outline': fileDocumentOutline,
  'mdi:file-tree': fileTree,
  'mdi:folder-open-outline': folderOpenOutline,
  'mdi:folder-outline': folderOutline,
  'mdi:help-circle': helpCircle,
  'mdi:lightbulb-on-outline': lightbulbOnOutline,
  'mdi:key-variant': keyVariant,
  'mdi:lock-outline': lockOutline,
  'mdi:menu': menu,
  'mdi:menu-open': menuOpen,
  'mdi:message-text': messageText,
  'mdi:message-text-outline': messageTextOutline,
  'mdi:minus': minus,
  'mdi:page-first': pageFirst,
  'mdi:page-last': pageLast,
  'mdi:pause-circle-outline': pauseCircleOutline,
  'mdi:pencil': pencil,
  'mdi:plus': plus,
  'mdi:plus-circle-outline': plusCircleOutline,
  'mdi:reload': reload,
  'mdi:school-outline': schoolOutline,
  'mdi:shield-account': shieldAccount,
  'mdi:sync': sync,
  'mdi:tag-outline': tagOutline,
  'mdi:trash-can-outline': trashCanOutline,
  'mdi:translate': translate,
  'mdi:view-dashboard': viewDashboard,
  'mdi:view-quilt-outline': viewQuiltOutline
} satisfies IconRegistry
